/** What the tab holding the line is doing, as other tabs see it. */
export type OtherTabCall = 'none' | 'ringing' | 'connected';

/** Ringing = incoming or outgoing, not answered yet. Taking the line over ends either kind. */
export function callForOtherTabs(call: { phase: string } | null, hasSession: boolean): OtherTabCall {
  if (call?.phase === 'connected') return 'connected';
  if (call && call.phase !== 'ended') return 'ringing';
  return hasSession ? 'ringing' : 'none';
}
